import { Button, Grid, TextField, Typography } from "@mui/material";
import React, { useState, useRef } from "react";
import InventoryTabs from "../../../Componants/Common/Inventory tabs/InventoryTabs";
import InputFileUpload from "../../../Componants/Common/Bulk Upload/InputFileUpload";
import CommonButton from "../../../Componants/Common/Button";
import Template from "../../../Componants/Common/Bulk Upload/Template";
import Subheader from "../../../Componants/Common/Subheader";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import FileSaver from "file-saver";
import {
  fetchStockGRNTemplate,
  fetchReferenceCode,
  downloadStockGRNReference,
  uploadStockGRN,
} from "../../../API Service/apiService";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "../../../Componants/Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const StockGRN = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const formik = useFormik({
    initialValues: {
      GRN_reference_number: "",
      GRN_remarks: "",
    },
    validationSchema: Yup.object({
      GRN_reference_number: Yup.string()
        .required("GRN Reference Number is required")
        .matches(/^[a-zA-Z0-9]+$/, "GRN Reference Number must be alphanumeric"),
      GRN_remarks: Yup.string()
        .required("GRN Remarks are required")
        .max(100, "GRN Remarks must be at most 100 characters"),
    }),
    onSubmit: async (values) => {
      if (selectedFile) {
        try {
          setLoading(true);
          const formData = new FormData();
          formData.append('GRN_reference_number', values.GRN_reference_number);
          formData.append('GRN_remarks', values.GRN_remarks);
          formData.append('file', selectedFile);
          

          const response = await uploadStockGRN(formData);

          if (response.status === 299) {
            const failedRowsLink = response.data.failedRowsLink;
            toast(
              (t) => (
                <div
                  style={{ display: "flex", alignItems: "center", padding: "10px" }}
                >
                  <span
                    style={{
                      color: "yellow",
                      fontSize: "1.5rem",
                      marginRight: "12px",
                    }}
                  >
                    ⚠️
                  </span>
                  <div style={{ flex: 1 }}>
                    <strong>Import completed with some errors.</strong>
                    <div style={{ marginTop: "5px" }}>
                      <div>Valid Count: {response.data.validCount}</div>
                      <div>Invalid Count: {response.data.invalidCount}</div>
                      <div>Duplicate Count: {response.data.duplicateCount}</div>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => window.open(failedRowsLink, "_blank")}
                        style={{ marginTop: "8px" }}
                      >
                        Download Failed Rows
                      </Button>
                    </div>
                  </div>
                  <span
                    style={{
                      marginLeft: "auto",
                      cursor: "pointer",
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "1.5rem",
                    }}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    &times;
                  </span>
                </div>
              ),
              { duration: Infinity }
            );
          } else if (response.status === 200) {
            toast.success(response?.message || "Stock GRN uploaded successfully!");
          }

          // Reset form and file input
          formik.resetForm();
          setSelectedFile(null);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          toast.error(error?.response?.data?.message || "Error uploading Stock GRN. Please try again.");
        } finally {
          setLoading(false);
        }
      } else {
        toast.error("Please select a file to upload.");
      }
    },
  });

  const handleDownloadGRNTemplate = async () => {
    try {
      setLoading(true);
      const response = await fetchStockGRNTemplate();

      if (response) {
        let filename = "Stock_GRN_Template.xlsx"; // default
        if (response.headers && response.headers["content-disposition"]) {
          const disposition = response.headers["content-disposition"];
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }
        const blob = new Blob([response.data ? response.data : response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
        toast.success("GRN Template downloaded successfully!");
      } else {
        throw new Error("No data received for GRN template.");
      }
    } catch (error) {
      console.error("Error downloading GRN template:", error);
      toast.error("Error downloading GRN template. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadReferenceCode = async () => {
    try {
      setLoading(true);
      const response = await downloadStockGRNReference();
      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, "Stock_GRN_Reference_Code.xlsx");
        toast.success("Reference Code downloaded successfully!");
      } else {
        throw new Error("No data received for reference code.");
      }
    } catch (error) {
      console.error("Error downloading reference code:", error);
      toast.error("Error downloading reference code. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container>
      {loading && <Loader/>}
      <Toaster/>
      <HeaderNavigation value={"Stock GRN"} />
      <InventoryTabs selectedTab={"two"} />

      <Grid
        container
        sx={{
          // background: "#EFF3FE",
          // marginLeft: "10px",
          // marginTop: "4px",
          // marginRight: "10px",
          // fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          // width: "100%",
          // borderRadius: "5px",
          // padding: "10px",
          // fontWeight: 600,
          backgroundColor: "#eff3fe",
          maxWidth: "100%",
          margin: "10px",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <Grid container sx={{ marginBottom: "20px" }}>
          <Subheader heading={"Bulk Upload"} />
        </Grid>

        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            alignItems: "end",
          }}
        >
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <Typography>Upload File</Typography>
          </Grid>
        </Grid>
        <Grid container gap={10}>
          <Grid item>
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Upload"} handleOnClick={formik.handleSubmit} />
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <span onClick={handleDownloadGRNTemplate}>
              <Template label={"Download Template"} />
            </span>
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <span onClick={handleDownloadReferenceCode}>
              <Template label={"Download Reference Code"} />
            </span>
          </Grid>
        </Grid>
        <Grid container gap={5}>
          <Grid item>
            <TextField
              style={{ width: "12.5rem" }}
              id="GRN_reference_number"
              label="GRN Reference No."
              variant="standard"
              value={formik.values.GRN_reference_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.GRN_reference_number &&
                Boolean(formik.errors.GRN_reference_number)
              }
              helperText={
                formik.touched.GRN_reference_number &&
                formik.errors.GRN_reference_number
              }
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "12.5rem" }}
              id="GRN_remarks"
              label="GRN Remarks"
              variant="standard"
              value={formik.values.GRN_remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.GRN_remarks && Boolean(formik.errors.GRN_remarks)
              }
              helperText={
                formik.touched.GRN_remarks && formik.errors.GRN_remarks
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StockGRN;
